import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "hero pink-background block" }
const _hoisted_2 = { class: "hero-body" }
const _hoisted_3 = { class: "container is-fluid container-fullwidth" }
const _hoisted_4 = { class: "field is-flex is-justify-content-right" }
const _hoisted_5 = { class: "control buttons" }
const _hoisted_6 = {
  key: 0,
  class: "iframe"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")
  const _component_InfigoIframe = _resolveComponent("InfigoIframe")
  const _component_InfigoLoading = _resolveComponent("InfigoLoading")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("section", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_Title, { subtitle: "Explore our Editor Iframe, edit job" }),
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _createVNode("button", {
                type: "button",
                class: "button is-dark-infigo",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/shopping-list')))
              }, " Go to basket ")
            ])
          ]),
          (_ctx.openIframe)
            ? (_openBlock(), _createBlock("div", _hoisted_6, [
                _createVNode(_component_InfigoIframe, {
                  "product-id": _ctx.iframeProductId,
                  "job-id": _ctx.jobId,
                  onIframeLoaded: _ctx.iframeLoaded,
                  onItemAddedToBasket: _ctx.addToBasket
                }, null, 8, ["product-id", "job-id", "onIframeLoaded", "onItemAddedToBasket"])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_InfigoLoading, { key: 0 }))
      : _createCommentVNode("", true)
  ], 64))
}